export default __webpack_public_path__ + "static/media/gridview.3ca51073.svg";